module.exports = __webpack_public_path__ + "static/media/logoSmall.37d5b156.png";